import { useState } from "react";
import { HeroCard } from "../../cards/herocard/HeroCard";
import { Weather } from "../../../types/variables/Variables";
import { useLanguage } from "../../../components/contexts/LanguageContext";
import translations from '../../../components/translations';
import CustomInput from "../../autocomplete/AutoComplete";
import { useParams } from "../../../hooks/common/useParams";

const HomeHero = () => {
  const { add } = useParams()
  const { selectedLanguage } = useLanguage();

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
  };

  const onChange = (e: any, r: any, defaultOu: any) => {
    add("orgUnit", r?.id ?? defaultOu?.id)
    add("orgUnitName", r?.name ?? defaultOu?.name)
    add("parentId", r?.parent?.id ?? defaultOu?.parent?.id)
  }

  return (
    <section className="weather-banner-2" id="#home">
      <div className="container">
        <div className="content">
          <div className="row justify-content-between">
            <div className="col-xl-8 col-lg-6 mb-lg-0 mb-4">
              <div className="text">
                <h5 className="fw-6">
                  {translations[selectedLanguage].dailyForecast}
                </h5>
                <h2 className="fw-5 lh-120">
                  {translations[selectedLanguage].meteorologicalPortal}
                </h2>
                <p className="fs-19 fw-4 lh-150 bottom-space pt-0">
                  {translations[selectedLanguage].weatherDescription}
                </p>
                <div className="col-xl-9">
                  <form onSubmit={handleSubmit} autoComplete="off">
                    <CustomInput onChange={onChange} />
                  </form>
                </div>
              </div>
            </div>

            <HeroCard />
          </div>
        </div>
      </div>
    </section>
  );
};

export { HomeHero };
